import { TooltipWrapper, Icon } from "@zapier/design-system";
import styles from "./DraftTag.module.css";

interface DraftTagProps {
  assetType?: string;
}

export function DraftTag({ assetType = "asset" }: DraftTagProps) {
  return (
    <div className={styles.draftTag}>
      Draft
      <TooltipWrapper
        content={`This ${assetType} has not yet been created`}
        position="north"
      >
        {({ childProps }) => (
          <span
            {...childProps}
            style={{
              marginLeft: 4,
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <Icon name="navHelp" size={12} color="GrayWarm1" />
          </span>
        )}
      </TooltipWrapper>
    </div>
  );
}
